
import Form from "./Form.vue";
import { mapGetters } from "vuex";
import {
  SistemaMixin,
} from "@/modules/Application";

export default {
  name: "app-variacoes-create",
  data() {
    return {
      variacao: {
        nome: null,
        variaveis: []
      },
    };
  },
  components: {
    Form,
  },
  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
